import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

import { useBulkEscalarTickets } from '@/shared/actions/erp/tickets-soporte-cliente';
import { useFetchTicketAreas } from '@/shared/actions/erp/tickets-soporte-cliente/gestion-tickets-catalogos.actions';

type ModalBulkEscalarProps = {
  open: boolean;
  onClose: () => void;
  ticketIds: string[];
  onSuccess: (operacionId: string) => void;
};

type FormData = {
  area_destino: string;
  comentario: string;
};

export default function ModalBulkEscalar({ open, onClose, ticketIds, onSuccess }: ModalBulkEscalarProps) {
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: { area_destino: '', comentario: '' },
  });

  const { data: areasData, isLoading: isLoadingAreas } = useFetchTicketAreas();
  const bulkEscalar = useBulkEscalarTickets();

  const areas = (areasData?.data as any)?.data ?? areasData?.data ?? [];

  const onSubmit = (data: FormData) => {
    bulkEscalar.mutate(
      {
        ticket_ids: ticketIds,
        area_destino: data.area_destino,
        comentario: data.comentario,
      },
      {
        onSuccess: (res) => {
          const operacionId = (res as any)?.data?.data?.operacion_id;
          reset();
          onClose();
          if (operacionId) onSuccess(operacionId);
        },
      }
    );
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Escalar Tickets Masivamente</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
        <Alert severity="info" sx={{ mt: 1 }}>
          Se escalarán <strong>{ticketIds.length}</strong> ticket(s) al área seleccionada.
        </Alert>

        <Controller
          name="area_destino"
          control={control}
          rules={{ required: 'El area destino es requerida' }}
          render={({ field }) => (
            <TextField
              {...field}
              select
              label="Area Destino"
              fullWidth
              size="small"
              error={!!errors.area_destino}
              helperText={errors.area_destino?.message}
              disabled={isLoadingAreas}
            >
              {areas.map((area: any) => (
                <MenuItem key={area.id_area} value={area.id_area}>
                  {area.nombre}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
        <TextField
          {...register('comentario', { required: 'El comentario es requerido' })}
          label="Comentario"
          multiline
          minRows={3}
          fullWidth
          size="small"
          error={!!errors.comentario}
          helperText={errors.comentario?.message}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          variant="contained"
          disabled={bulkEscalar.isPending}
        >
          {bulkEscalar.isPending ? 'Iniciando...' : `Escalar (${ticketIds.length})`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
